import GraphEvent from '@antv/g-base/lib/event/graph-event';
/**
 *
 * @param group 分组
 * @param eventName 事件名
 * @param eventObject 事件对象
 */
export function propagationDelegate(group, eventName, eventObject) {
    var event = new GraphEvent(eventName, eventObject);
    event.target = group;
    event.propagationPath.push(group); // 从当前 group 开始触发 delegation
    group.emitDelegation(eventName, event);
    var parent = group.getParent();
    // 执行冒泡
    while (parent) {
        // 委托事件要先触发
        parent.emitDelegation(eventName, event);
        event.propagationPath.push(parent);
        parent = parent.getParent();
    }
}
//# sourceMappingURL=event.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@antv_component@0.6.3@@antv/component/esm/util/event.js
// module id = null
// module chunks = 